import { SectionOfDashboard } from "@/modules/DashboardTemplate/models/SectionOfDashboard";
import { Utils } from "@/shared/utils/utils";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  name: "BarChart",
  computed: {
    ...mapGetters({
      sectionsOfDashboardStore: "getSectionsOfdashboard"
    })
  }
})
export default class BarChart extends Vue {
  sectionsOfDashboardStore!: Array<SectionOfDashboard>;

  @Prop() propertiesToChart!: {
    //chartName: string,
    indexSectionOfDashboard: number;
    indexCollectionFilter: number;
    groupBy: [];
    chartType: string;
    chartColor: { hex: string };
  };

  chartOptions = {};

  mounted() {
    console.log("mounted barchart", this.propertiesToChart);
    this.chart();
  }

  @Watch("propertiesToChart", { deep: true })
  onChangeData() {
    this.chart();
  }

  chart() {
    console.log("propertiesToChart", this.propertiesToChart);

    const data = this.sectionsOfDashboardStore[
      this.propertiesToChart.indexSectionOfDashboard
    ].collections[this.propertiesToChart.indexCollectionFilter];
    console.log("data barchart", this.propertiesToChart.chartType);
    console.log("data", data);

    const yAxis: any[] = [{ type: "value" }];
    const xAxis: any[] = [{ type: "category", data: data.chartData.xAxis }];
    if (this.propertiesToChart.chartType.includes("horizontal")) {
      yAxis[0] = { type: "category", data: data.chartData.xAxis };
      xAxis[0] = { type: "value" };
    }
    console.log(
      "this.propertiesToChart.chartColor",
      this.propertiesToChart.chartColor
    );

    this.chartOptions = {
      color: Utils.generateColorsTones(
        this.propertiesToChart.chartColor.hex,
        3
      ) as never[],
      title: {
        text: data.chartName
      },
      tooltip: {},
      legend: {
        data: [this.propertiesToChart.groupBy]
      },
      xAxis,
      yAxis,
      series: [
        {
          name: data.collection[0].name,
          type: "bar",
          data: data.chartData.data[0].data
        }
      ]
    };
  }
}
